<div>
	<div [formGroup]="searchForm" style="display: flex">
		<mat-form-field>
			<mat-label>{{ "MAIN_APP_ADRESSES.adressenSuchen" | translate }}</mat-label>
			<input #input (keydown)="enterPressed($event)" formControlName="searchString" matInput placeholder="Begriff eingeben"/>
		</mat-form-field>
		<mat-checkbox class="cbInaktiv-margin" formControlName="activeOnly" style="margin: 0 0 0 12px">
			{{ "MAIN_APP_ADRESSES.nurAktiveAdressenSuchen" | translate }}
		</mat-checkbox>
		<button (click)="search()" mat-raised-button style="align-self: center;">{{ "MAIN_APP_ADRESSES.adressenSuchen" | translate }}</button>
	</div>
	<div class="table">
		<table [dataSource]="(data$ | async)?.addresses!" class="mat-elevation-z8" mat-table>
			<!-- Adress-Nr. Column -->
			<ng-container matColumnDef="adressNo">
				<th *matHeaderCellDef mat-header-cell>Nr.</th>
				<td (click)="highlight(element)" *matCellDef="let element" mat-cell>{{ element.adressNo }}</td>
			</ng-container>

			<!-- Name Column -->
			<ng-container matColumnDef="lastName">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_ADRESSES.name" | translate }}
				</th>
				<td (click)="highlight(element)" *matCellDef="let element" mat-cell>{{ element.lastName }}</td>
			</ng-container>

			<!-- Vorname Column -->
			<ng-container matColumnDef="firstName">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_ADRESSES.vorname" | translate }}
				</th>
				<td (click)="highlight(element)" *matCellDef="let element" mat-cell>
					{{ element.firstName }}
				</td>
			</ng-container>

			<!-- Strasse Column -->
			<ng-container matColumnDef="street1">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_ADRESSES.strasse" | translate }}
				</th>
				<td (click)="highlight(element)" *matCellDef="let element" mat-cell>{{ element.street1 }}</td>
			</ng-container>

			<!-- Plz Column -->
			<ng-container matColumnDef="zip">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_ADRESSES.plz" | translate }}
				</th>
				<td (click)="highlight(element)" *matCellDef="let element" mat-cell>{{ element.zip }}</td>
			</ng-container>

			<!-- Ort Column -->
			<ng-container matColumnDef="city">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_ADRESSES.ort" | translate }}
				</th>
				<td (click)="highlight(element)" *matCellDef="let element" mat-cell>{{ element.city }}</td>
			</ng-container>

			<!-- Telefon Column -->
			<ng-container matColumnDef="phone01">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_ADRESSES.telefon" | translate }}
				</th>
				<td *matCellDef="let element" mat-cell>
					<a href="tel:{{ element.phone01 }}">{{ element.phone01 }}</a>
				</td>
			</ng-container>

			<!-- Mobile Column -->
			<ng-container matColumnDef="phone03">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_ADRESSES.mobile" | translate }}
				</th>
				<td *matCellDef="let element" mat-cell>
					<a href="tel:{{ element.phone03 }}">{{ element.phone03 }}</a>
				</td>
			</ng-container>

			<!-- Mail Column -->
			<ng-container matColumnDef="email">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_ADRESSES.email" | translate }}
				</th>
				<td *matCellDef="let element" mat-cell>
					<a href="mailto:{{ element.email }}">{{ element.email }}</a>
				</td>
			</ng-container>

			<!-- Land Column -->
			<ng-container matColumnDef="country">
				<th *matHeaderCellDef mat-header-cell>
					{{ "MAIN_APP_ADRESSES.land" | translate }}
				</th>
				<td (click)="highlight(element)" *matCellDef="let element" mat-cell>{{ element.country }}</td>
			</ng-container>

			<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
			<tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>

			<!-- Row shown when there is no matching data. -->
			<tr *matNoDataRow class="mat-row">
				<div *ngIf="hasSearched$ | async">
					{{ "MAIN_APP_ADRESSES.noDataMatchingTheFilter" | translate }}
					"{{ input.value }}"
				</div>
				<ng-template #searchFailed>
					{{ "MAIN_APP_ADDRESS.ADDRESS_SEARCH.searchExplanation" | translate }}
				</ng-template>
			</tr>
		</table>

		<mat-paginator (page)="changePaging($event)" [length]="(data$ |async )?.resultCount" [pageIndex]="(pageOptions | async)?.page" [pageSizeOptions]="[5, 10, 25, 50]"
		               [pageSize]="pageOptions"></mat-paginator>
	</div>
</div>

